import _Number$isInteger from "@babel/runtime-corejs2/core-js/number/is-integer";
import "core-js/modules/es6.string.bold";
import { css } from 'styled-components';
import { fontFamilySansSerif } from '@origin-digital/helper';
import { FontWeights } from '../consts/metrics.const';
export var letterSpacing = "letter-spacing: 0px;";
export var antialiased = "\n-moz-osx-font-smoothing: grayscale;\n-webkit-font-smoothing: antialiased;\n";
export var sansSerif = fontFamilySansSerif;
export var overflow = css(["", ";"], function (_ref) {
  var overflow = _ref.overflow;
  return overflow === 'breakWord' && 'hyphens: auto; word-wrap: break-word;';
});
export var truncate = css(["", ";"], function (_ref2) {
  var truncate = _ref2.truncate;
  return truncate && "max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;";
});
export var textAlign = css(["", ";"], function (_ref3) {
  var align = _ref3.align;
  return align ? "text-align:".concat(align) : '';
});
export var italic = css(["", ";"], function (_ref4) {
  var italic = _ref4.italic;
  return "font-style: ".concat(italic ? 'italic' : 'normal');
});
export var bold = css(["", ";"], function (_ref5) {
  var bold = _ref5.bold,
      fontWeight = _ref5.fontWeight;
  return fontWeight ? "font-weight: ".concat(_Number$isInteger(fontWeight) ? fontWeight : FontWeights[fontWeight.toUpperCase()]) : "font-weight: ".concat(bold ? FontWeights.BOLD : FontWeights.REGULAR);
}); // TODO: this must change to use metrics object.

var FONT_SIZES = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 24
};
var LINE_HEIGHTS = {
  xs: 20,
  sm: 24,
  md: 24,
  lg: 24,
  xl: 28
};
export var fontSize = css(["", ";"], function (_ref6) {
  var size = _ref6.size,
      lineHeight = _ref6.lineHeight,
      fontSize = _ref6.fontSize;
  var lineHeightCss = '';
  var fontSizeCss = '';

  if (size || lineHeight) {
    lineHeightCss = "line-height: ".concat(lineHeight ? lineHeight : LINE_HEIGHTS[size], "px;");
  }

  if (size || fontSize) {
    fontSizeCss = "font-size: ".concat(fontSize ? fontSize : FONT_SIZES[size], "px;");
  }

  return lineHeightCss + fontSizeCss;
});
export var lineHeight = css(["", ";"], function (_ref7) {
  var lineHeight = _ref7.lineHeight;
  return lineHeight && "line-height: ".concat(lineHeight, "px;");
});
export var lineClamp = css(["", ";"], function (_ref8) {
  var lines = _ref8.lines;
  return lines ? "white-space: normal;\n            display: -webkit-box;\n                -webkit-box-orient: vertical;\n            line-clamp: ".concat(lines, ";\n    -webkit-line-clamp: ").concat(lines, ";") : '';
});
export var inline = css(["", ";"], function (_ref9) {
  var inline = _ref9.inline;
  return inline ? "display: inline;" : '';
});
export var noSelect = css(["", ";"], function (_ref10) {
  var noSelect = _ref10.noSelect;
  return noSelect ? "user-select: none;" : '';
});